export default __webpack_public_path__ + "static/media/at-sign.4990fd9d.svg";